/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { IOrderDetails } from '../../../models/product-detail';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
interface ISpecialInstructions {
    orderDetails: IOrderDetails;
    onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    showHideSpecialInstructions: (show: boolean) => void;
    name: string;
}

const SpecialInstructions = ({
    orderDetails,
    onChange,
    showHideSpecialInstructions,
    name,
}: ISpecialInstructions) => {
    const intl = useIntl();
    return (
        <div>
            {orderDetails.showSpecialInstructions ? (
                <div>
                    <textarea
                        className="pdp-text-area"
                        name={name}
                        value={orderDetails.specialInstructions!}
                        onChange={onChange}
                        maxLength={250}
                    >
                        {orderDetails.specialInstructions!}
                    </textarea>
                    <a
                        onClick={() => showHideSpecialInstructions(false)}
                        className="fas fa-window-close"
                    />
                </div>
            ) : (
                <label>
                    <a onClick={() => showHideSpecialInstructions(true)}>
                        {intl.formatMessage({
                            id: 'Add_Special_Instructions',
                            defaultMessage: 'Add Special Instructions',
                        })}
                    </a>
                </label>
            )}
        </div>
    );
};

export default SpecialInstructions;
